import ApplicationsNewMenu from './ApplicationsNewMenu';

export default ApplicationsNewMenu;
